import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { type ExternalEntity } from '@/types';
import { type SportsInitialState } from './types';

const initialState: SportsInitialState = {
  sports: undefined,
};

export const sportsSlice = createSlice({
  name: 'sports',
  initialState,
  reducers: {
    setSports: (state, { payload }: PayloadAction<ExternalEntity[]>) => {
      state.sports = payload;
    },
  },
});

export const { reducer: sportsReducer } = sportsSlice;
